<div
  class="header-row"
  *ngIf="true">
  <div
    class="shift-edit-label"
    [class.warning]="invalid$ | async">
    {{ ("shift" | i18n) || "shift" | titlecase }}
    <span class="required-star">*</span>
  </div>
  <mat-checkbox
    *ngIf="isNewJob$ | async"
    class="new-checkbox-color"
    name="hasMultipleShifts"
    [ngModel]="hasMultipleShifts$ | async"
    (ngModelChange)="hasMultipleShifts$.next($event)"
    (change)="toggleHasMultipleShifts($event)"
    [attr.data-cy]="
      'include-multiple-shifts-checkbox-' + (hasMultipleShifts$ | async)
    ">
    {{ ("activateMultipleShifts" | i18n) || "Geteilte Schichten aktivieren" }}
  </mat-checkbox>
</div>
<ng-container *ngIf="!(isNewJob$ | async) && (shifts$ | async)?.length">
  <div class="shifts-list">
    <div
      class="shift-label"
      *ngFor="let shift of shifts$ | async; trackBy: trackByShift">
      <div class="shift-chip">
        {{
          shift.label
            ? shift.label
            : ("shifts." + shift.shift | i18n | titlecase)
        }}
      </div>
      <div class="shift-time">
        <span
          *ngIf="shift.originalFrom || shift.originalTo"
          class="original-times">
          {{ shift.originalFrom || shift.from | time }} -
          {{ shift.originalTo || shift.to | time }}
        </span>
        <span> {{ shift.from | time }} - {{ shift.to | time }}</span>
      </div>
      <mat-icon
        *ngIf="canEditShifts$ | async"
        class="edit-icon size-20"
        svgIcon="pencil-outline"
        matListIcon
        (click)="openShiftEditDialog($event, shift)"
        [matTooltip]="('editTimes' | i18n) || 'Zeiten bearbeiten'"
        data-cy="edit-shift-button"></mat-icon>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="isNewJob$ | async">
  <ng-container *ngIf="!(hasMultipleShifts$ | async)">
    <mat-radio-group
      [class.warning]="invalid$ | async"
      class="shifts-list"
      [ngModel]="getSelectedShiftFromAvailable()"
      (ngModelChange)="ngModelSetFirstShift($event)"
      name="shifts"
      required
      [attr.data-cy]="'shift-select-' + (shifts$ | async)?.[0]?.id">
      <mat-radio-button
        *ngFor="let shift of availableShifts$ | async; let i = index"
        [value]="shift"
        [attr.data-cy]="
          'shift-option-' +
          shift.id +
          (isShiftSelected(shift) ? 'active' : 'inactive')
        ">
        <div class="shift-content">
          <span
            class="shift-label"
            data-cy="shift-label"
            [class.warning]="
              (shifts$ | async) &&
              shift.from == shift.to &&
              (((shifts$ | async)?.[0] && (shifts$ | async)?.[0]?.shift == shift.shift) ||
                ((shifts$ | async)?.[1] && (shifts$ | async)?.[1]?.shift == shift.shift))
            ">
            <div class="shift-chip">
              {{
                shift.label
                  ? shift.label
                  : ("shifts." + shift.shift | i18n | titlecase)
              }}
            </div>
            <div class="shift-time">
              <span> {{ shift.from | time }} - {{ shift.to | time }} </span>
            </div>
          </span>

          <mat-icon
            *ngIf="canEditShifts$ | async"
            svgIcon="pencil-outline"
            matListIcon
            class="edit-icon size-20"
            (click)="openShiftEditDialog($event, shift)"
            [matTooltip]="('editTimes' | i18n) || 'Zeiten bearbeiten'"
            data-cy="edit-shift-button"></mat-icon>
        </div>
      </mat-radio-button>
    </mat-radio-group>
  </ng-container>
  <ng-container *ngIf="hasMultipleShifts$ | async">
    <div
      class="shifts-list"
      [class.warning]="invalid$ | async">
      <div *ngFor="let shift of availableShifts$ | async">
        <mat-checkbox
          color="primary"
          class="shift-checkbox"
          [checked]="isShiftSelected(shift)"
          (change)="toggleShift($event, shift)"
          [attr.data-cy]="
            'shift-option-' +
            shift.id +
            (isShiftSelected(shift) ? 'active' : 'inactive')
          ">
          <div class="shift-content">
            <span
              class="shift-label"
              data-cy="shift-label"
              [class.warning]="
                (shifts$ | async) &&
                shift.from == shift.to &&
                (((shifts$ | async)?.[0] && (shifts$ | async)?.[0]?.shift == shift.shift) ||
                  ((shifts$ | async)?.[1] && (shifts$ | async)?.[1]?.shift == shift.shift))
              ">
              <div class="shift-chip">
                {{
                  shift.label
                    ? shift.label
                    : ("shifts." + shift.shift | i18n | titlecase)
                }}
              </div>
              <div class="shift-time">
                <span> {{ shift.from | time }} - {{ shift.to | time }} </span>
              </div>
            </span>
            <mat-icon
              *ngIf="canEditShifts$ | async"
              svgIcon="pencil-outline"
              matListIcon
              class="edit-icon size-20"
              (click)="openShiftEditDialog($event, shift)"
              [matTooltip]="('editTimes' | i18n) || 'Zeiten bearbeiten'"
              data-cy="edit-shift-button"></mat-icon>
          </div>
        </mat-checkbox>
      </div>
    </div>
  </ng-container>
</ng-container>
